export default {
    setSelectedProduct(state, selected_product) {
        state.selected_product = selected_product 
    }
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/mutations/selectedProductMutations.js